import React from 'react';

import './NoButtonCTA.scss';

const NoButtonCTA = ({ amount }) => {
  return (
    <div className="NoButtonCTAContainer">
      <h2>Our typical Investment amount for homes like yours is</h2>
      <h1>{amount}</h1>
      <p>with no monthly payments</p>
    </div>
  );
};

export default NoButtonCTA;
